module.exports = __webpack_public_path__ + "static/media/smellEnvelope.3d18546f.jpg";